import { Component, effect, input } from "@angular/core";
import { TableRow } from "../../info-table/info-table.component";
import { AreaConverterPipe } from "../../../../shared/pipes/areaconverter";
import { DefaultConverterPipe } from "../../../../shared/pipes/defaultconverter.pipe";
import { SeeMoreButtonComponent } from "../../../../shared-components/seemore-button/seemore-button.component";
import { UnitsTableComponent } from "../units-table/units-table.component";
import { BuildingChangeComponent } from "../building-change/building-change.component";
import { SubGroupComponent } from "../sub-group/sub-group.component";
import { CommonModule, NgClass } from "@angular/common";
import { EvExpandedIconComponent } from "ev-expanded-icon";
import { PropertyInformation } from "src/models/estate/property-information.model";
import { PublicBuildingInfo, UnitInfo } from "src/models/estate/public-building-info.model";
import { EnergyLabelColor } from "src/models/common/energy.enums";

@Component({
    selector: "buildings-accordions",
    templateUrl: "./buildings-accordions.component.html",
    styleUrls: ["../../styles/component-accordion.scss", "./buildings-accordions.component.scss"],
    imports: [
        CommonModule,
        NgClass,
        EvExpandedIconComponent,
        SubGroupComponent,
        BuildingChangeComponent,
        UnitsTableComponent,
        SeeMoreButtonComponent,
        DefaultConverterPipe,
        AreaConverterPipe,
    ],
})
export class BuildingsAccordionsComponent {
    propertyInformation = input.required<PropertyInformation[]>();
    maxToShow = input<number>(10);

    readonly initmaxToShowUnitTable: number = 15;
    readonly seeMoreSteps = 5;
    initmaxToShowUnitTableValues: number[] = [];
    _currentToShow: number = 0;
    buildingstables: Table[];
    breeamArray = [false, false, false, false, false];
    buildings: PropertyInformation[] = [];

    constructor() {
        effect(() => {
            const infos = this.propertyInformation();

            if (infos && infos.length) {
                this._currentToShow = this.maxToShow();
                this.buildings = [...infos];
                this.makeTable();
            } else {
                this.buildings = [];
                this.buildingstables = [] as any;
            }
        });
    }

    getEnergyLabelClass(energyLetter: string, energyLabelColorId: number): string {
        if (!energyLetter || !energyLabelColorId) {
            return "";
        }

        return energyLetter.toLocaleLowerCase() + "-" + EnergyLabelColor[energyLabelColorId].toLowerCase();
    }

    onUnitTableExpanded(expanded: boolean, expanedIndex: number): void {
        this.initmaxToShowUnitTableValues[expanedIndex] = expanded ? this.initmaxToShowUnitTable : this.initmaxToShowUnitTableValues[expanedIndex];
    }

    //Might be needed if we add infopageStateService, otherwise remove
    // handleInforPageStateChange(s: AccordionState[]): void {
    //     this._currentToShow = this.maxToShow();
    //     this.makeTable();
    // }

    onSeeMoreClicked(): void {
        this.makeTable();
    }

    private makeTable(): void {
        let result = [];
        let index: number = 0;
        let changes: PublicBuildingInfo[] = [];

        for (let info of this.buildings) {
            index = index + 1;
            if (index > this._currentToShow) {
                break;
            }

            if (info.buildingInfo.reconstructionOrder > 0) {
                changes.push(info.buildingInfo);
                continue;
            }

            let left: any[] = [];
            let right: any[] = [];
            let header: string = info.buildingInfo.buildingType;
            let arealInfo: number = info.buildingInfo.usableArea;
            const table = new Table(header, arealInfo, left, right);
            table.usageUnits = info.unitsInfo;
            table.buildingInfo = info.buildingInfo;

            result.push(table);
        }

        changes.forEach((change) => {
            result.forEach((element) => {
                if (element.buildingInfo.parentBuildingID === change.parentBuildingID) {
                    element.changes.push(change);
                }
            });
        });

        this.initmaxToShowUnitTableValues = result.map(() => this.initmaxToShowUnitTable);

        this.buildingstables = result;
    }
}

export class Table {
    constructor(
        public header: string,
        public arealchages: number,
        public leftcolumn: TableRow[],
        public rightcolumn: TableRow[],
    ) {}

    expanded: boolean = false;
    usageUnits: UnitInfo[] = [];
    buildingInfo: PublicBuildingInfo;
    changes: PublicBuildingInfo[] = [];
}
